import React from "react";
import "./wizard-preview.scss";

export interface PreviewDslBlockProps {
  /** Any JSON-serializable value; rendered via JSON.stringify(value, null, 2). */
  value: unknown;
  /** Optional caption shown above the block. */
  caption?: string;
}

/**
 * Read-only monospace code block for a compiled DSL / serialized policy.
 * Feed it the object directly (e.g. serializeConditionTree(...)) — it
 * stringifies internally.
 */
export const PreviewDslBlock: React.FC<PreviewDslBlockProps> = ({
  value,
  caption,
}) => (
  <div className="tlx-preview-dsl">
    {caption && <span className="tlx-preview-dsl__caption">{caption}</span>}
    <pre className="tlx-preview-dsl__code">
      <code>{JSON.stringify(value, null, 2)}</code>
    </pre>
  </div>
);

export default PreviewDslBlock;
